import about from './about.module'
export default about
